<template>
  <div class="block-credit">
    <div class="container">
      <div class="block-credit__img">
        <img src="../images/background/3.jpg" alt="Geely Coolray" />
      </div>
      <section class="block-credit__content">
        <h2 class="block-credit__title">
          <span>СПЕЦИАЛЬНЫЕ</span><br />
          КРЕДИТНЫЕ ПРЕДЛОЖЕНИЯ
        </h2>
        <callback-form
          class="block-credit__form"
          v-on="$listeners"
          :data="{ type: 'sale', form: 'credit' }"
          btn_theme="button_theme_white"
          text-color="white"
        >
          Получить предложение
        </callback-form>
      </section>
    </div>
  </div>
</template>

<script>
import CallbackForm from "./callback-form";
import Mixin from "../common/mixin";
import Finance from "../common/finance";

export default {
  name: "block-credit",
  components: { CallbackForm },
  mixins: [Mixin, Finance],
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.block-credit {
  .container {
    max-width: 1518px;
    display: flex;
    align-items: center;
    padding: 0;
    background-color: #021724;
  }

  &__img {
    max-width: 756px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    color: #fff;
    padding: 25px 0;
    padding-left: 159px;
    padding-right: 10px;
  }

  &__title {
    font-weight: bold;
    font-size: 36px;
    line-height: 43px;
    margin-bottom: 27px;

    span {
      font-weight: bold;
      color: $red;
    }
  }

  &__form {
    max-width: 318px;
  }
}

@media (max-width: 1920px) {
  .block-credit {
    &__content {
      padding-left: calcFontSize(10, 159, 800, 1920);
    }
  }
}

@media (max-width: 1024px) {
  .block-credit {
    .container {
      flex-direction: column;
      background-color: transparent;
    }

    &__img {
      width: 100%;
      max-width: 100%;

      img {
        width: 100%;
      }
    }

    &__content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      background-color: #021724;
    }
  }
}

@media (max-width: 450px) {
  .block-credit {
    &__title {
      font-size: 18px;
      line-height: 19px;
    }
  }
}
</style>
